// FR/DE strings for insights.html (English lives in the HTML).
// Article cards are translated in data/insights-index.json (per-entry "i18n").
window.FORSYT_PAGE_I18N = {
  fr: {
    "hub.hero.title":
      "Là où la performance des BESS devient une base de décision.",
    "hub.bp.title": "Ce que BenchmarkPro apporte concrètement à votre actif",
    "hub.bp.sub":
      "Nous transformons l'analyse a posteriori en intelligence actionnable. BenchmarkPro rejoue l'historique de votre batterie dans le strict respect de ses limites physiques pour établir une <span class=\"accent\">baseline de revenus atteignables</span>, afin de distinguer clairement les vents contraires du marché des manquements opérationnels.",
    "hub.pnl.eyebrow":
      "Du P&amp;L réalisé au <span class=\"accent\">P&amp;L atteignable</span>",
    "hub.pnl.p1":
      "La plupart des reportings BESS commencent et s'arrêtent au P&amp;L réalisé. Ce chiffre mêle prix de marché, contraintes de l'actif et choix de l'agrégateur : difficile, dès lors, de savoir si une année décevante tient à de mauvaises conditions de marché ou à une sous-performance.",
    "hub.pnl.p2":
      "BenchmarkPro prend le problème par l'autre bout. Nous nous demandons d'abord ce que votre actif aurait raisonnablement pu gagner s'il avait été exploité, sur les mêmes prix historiques, par un trader rigoureux et conscient des contraintes physiques. Ce n'est qu'ensuite que nous comparons ce <span class=\"accent\">P&amp;L atteignable</span> à ce que votre optimiseur ou agrégateur a réellement délivré.",
    "hub.pnl.p3":
      "Le résultat n'est pas une prévision de plus, mais un <span class=\"accent\">jumeau fondé sur les faits</span> : un benchmark propre à l'actif, qui se comporte comme un trader prudent mais compétent pilotant votre batterie dans ses contraintes réelles.",
    "hub.engine.text":
      "Au cœur de BenchmarkPro, un moteur de dispatch reconstitue la vie de votre batterie par <span class=\"accent\">pas de 15 minutes</span>. Nous reproduisons la séquence de trading telle qu'elle se déroule : engagements day-ahead d'abord, ajustements en intraday ensuite, puis règlement des écarts en temps réel selon la physique exacte de votre site. Vous disposez ainsi d'un jumeau cohérent pour auditer la performance :",
    "hub.engine.l1":
      "Voyez à quelle fréquence l'actif est resté à l'arrêt alors qu'il aurait pu travailler.",
    "hub.engine.l2":
      "Identifiez les intervalles où il est resté positionné sur le mauvais produit.",
    "hub.engine.l3":
      "Vérifiez comment les offres ont réagi, ou non, aux signaux de prix.",
    "hub.engine.l4":
      "Prenez du recul sur les revenus mensuels empilés ou zoomez sur les journées critiques.",
    "hub.engine.caption":
      "Replay détaillé du dispatch sur le day-ahead, l'intraday et les services système.",
    "hub.trust.eyebrow":
      "Adopté par les propriétaires, investisseurs et optimiseurs",
    "hub.trust.sub":
      "Un benchmark ne mérite d'être qualifié de bancable que si les parties prenantes financières adhèrent à l'approche, comprennent les hypothèses et font confiance à l'exécution. BenchmarkPro expose les principaux leviers qui font varier le P&amp;L (rendement, limites de cyclage, dégradation, arbitrage entre produits) afin que vous puissiez rattacher chaque écart de revenus à des décisions concrètes. Cette transparence fait du modèle, non plus une boîte noire, mais une référence durable pour les discussions commerciales :",
    "hub.trust.l1":
      "Les <span class=\"accent\">propriétaires</span> l'utilisent comme référence indépendante pour évaluer la performance de leur optimiseur et décider s'il faut relancer un appel d'offres ou renégocier.",
    "hub.trust.l2":
      "Les <span class=\"accent\">investisseurs et prêteurs</span> l'utilisent en due diligence pour recouper les business plans et comprendre si les trajectoires de revenus passées tenaient à l'opérateur ou au marché.",
    "hub.trust.l3":
      "Les <span class=\"accent\">optimiseurs</span> l'utilisent pour démontrer leur valeur ajoutée, en montrant comment leurs décisions suivent, voire dépassent, un benchmark prudent et conscient des contraintes physiques.",
    "hub.markets.eyebrow": "MARCHÉS COUVERTS",
    "hub.markets.sub":
      "La couverture porte sur les BESS utility-scale sur les marchés européens libéralisés de l'électricité.",
    "hub.markets.th_region": "Région",
    "hub.markets.th_energy": "Produits énergie",
    "hub.markets.th_capacity": "Produits capacité",
    "hub.markets.r1_region": "France, Allemagne, Autriche",
    "hub.markets.r1_energy":
      "Day-Ahead, Intraday, énergie aFRR, écarts (pénalités)",
    "hub.markets.cap_fcr_afrr": "FCR, capacité aFRR",
    "hub.markets.r2_region": "Pays-Bas, Belgique",
    "hub.markets.r2_energy": "Day-Ahead, Intraday, écarts (trading proactif)",
    "hub.markets.r3_region":
      "Pays nordiques (Danemark, Finlande, Norvège, Suède)",
    "hub.markets.r3_energy":
      "Day-Ahead, Intraday, énergie aFRR/mFRR, écarts (pénalités)",
    "hub.markets.r3_capacity":
      "FCR-N, FCR-D, FFR, capacité aFRR, capacité mFRR",
    "hub.markets.r4_region": "Grande-Bretagne",
    "hub.markets.r4_energy":
      "Day-Ahead, Intraday, Balancing Mechanism, écarts (pénalités)",
    "hub.markets.r5_region": "Italie",
    "hub.markets.r5_energy":
      "Day-Ahead, Intraday, MSD, Balancing Mechanism, écarts (pénalités)",
    "hub.archive_link": "Voir tous les insights",
    "hub.cta.eyebrow": "RESTONS EN CONTACT",
    "hub.cta.text":
      "Dites-nous quelles analyses vous seraient utiles ou ce que vous aimeriez voir dans nos benchmarks.",
    "hub.cta.btn": "Réserver un appel",
    "hub.cta.note":
      "Ou écrivez-nous à <a href=\"mailto:contact@forsytenergy.com\">contact@forsytenergy.com</a> et nous reviendrons vers vous.",
    "hub.modal.eyebrow": "TÉLÉCHARGER L'ÉTUDE DE CAS",
    "hub.modal.title": "Recevez l'analyse complète",
    "hub.modal.text":
      "Saisissez votre adresse e-mail professionnelle pour recevoir l'étude de cas BESS Dispatch France.",
    "hub.modal.newsletter":
      "Recevoir une sélection d'analyses, d'actualités et de communications de Forsyt.",
    "hub.modal.consent":
      "J'accepte les conditions et la <a href=\"privacy.html\" target=\"_blank\" style=\"color: var(--brand); text-decoration: none\">politique de confidentialité</a>.",
    "hub.modal.submit": "Télécharger le PDF",
  },
  de: {
    "hub.hero.title":
      "Wo BESS-Performance zur belastbaren Entscheidungsgrundlage wird.",
    "hub.bp.title": "Was BenchmarkPro konkret für Ihre Anlage leistet",
    "hub.bp.sub":
      "Wir machen aus dem Blick zurück verwertbare Erkenntnisse. BenchmarkPro spielt die Historie Ihrer Batterie unter strikten physikalischen Grenzen nach und erstellt so eine <span class=\"accent\">Baseline der erzielbaren Erlöse</span>. Damit lassen sich Marktgegenwind und operative Versäumnisse klar voneinander trennen.",
    "hub.pnl.eyebrow":
      "Vom realisierten P&amp;L zum <span class=\"accent\">erzielbaren P&amp;L</span>",
    "hub.pnl.p1":
      "Die meisten BESS-Reportings beginnen und enden beim realisierten P&amp;L. Diese Zahl vermischt Marktpreise, Anlagenrestriktionen und Entscheidungen des Aggregators. Deshalb lässt sich kaum sagen, ob ein schwaches Jahr an ungünstigen Marktbedingungen oder an Underperformance lag.",
    "hub.pnl.p2":
      "BenchmarkPro geht das Problem vom anderen Ende an. Zuerst fragen wir, was Ihre Anlage realistischerweise hätte erlösen können, wenn ein disziplinierter Trader, der die physikalischen Grenzen kennt, sie zu denselben historischen Preisen betrieben hätte. Erst dann vergleichen wir dieses <span class=\"accent\">erzielbare P&amp;L</span> mit dem, was Ihr Optimierer oder Aggregator tatsächlich geliefert hat.",
    "hub.pnl.p3":
      "Das Ergebnis ist keine weitere Prognose, sondern ein <span class=\"accent\">evidenzbasierter Zwilling</span>: ein anlagenspezifischer Benchmark, der sich wie ein vorsichtiger, aber kompetenter Trader verhält, der Ihre Batterie innerhalb ihrer realen Restriktionen betreibt.",
    "hub.engine.text":
      "Kern von BenchmarkPro ist eine Dispatch-Engine, die das Leben Ihrer Batterie in <span class=\"accent\">15-Minuten-Schritten</span> rekonstruiert. Wir bilden die Trading-Abfolge so nach, wie sie tatsächlich abläuft: zuerst Day-Ahead-Commitments, dann Anpassungen im Intraday und schließlich die Abrechnung der Ausgleichsenergie in Echtzeit – unter der exakten Physik Ihres Standorts. So entsteht ein konsistenter Zwilling, mit dem Sie die Performance prüfen können:",
    "hub.engine.l1":
      "Sehen Sie, wie oft die Anlage stillstand, obwohl sie hätte arbeiten können.",
    "hub.engine.l2":
      "Erkennen Sie Intervalle, in denen sie im falschen Produkt geblieben ist.",
    "hub.engine.l3":
      "Prüfen Sie, wie Gebote auf Preissignale reagiert haben – oder eben nicht.",
    "hub.engine.l4":
      "Zoomen Sie heraus auf monatliche Erlös-Stacks oder hinein in kritische Tage.",
    "hub.engine.caption":
      "Detailliertes Dispatch-Replay über Day-Ahead, Intraday und Systemdienstleistungen.",
    "hub.trust.eyebrow":
      "Das Vertrauen von Eigentümern, Investoren und Optimierern",
    "hub.trust.sub":
      "Ein Benchmark verdient die Bezeichnung bankfähig nur, wenn finanzielle Stakeholder den Ansatz mittragen, die Annahmen verstehen und der Umsetzung vertrauen. BenchmarkPro legt die wesentlichen Hebel offen, die das P&amp;L verändern (Wirkungsgrad, Zyklengrenzen, Degradation, Produktarbitrage), sodass Sie Erlöslücken auf konkrete Entscheidungen zurückführen können. Diese Transparenz macht aus dem Modell statt einer Blackbox eine dauerhafte Referenz für kommerzielle Gespräche:",
    "hub.trust.l1":
      "<span class=\"accent\">Eigentümer</span> nutzen es als unabhängige Referenz, um die Performance ihres Optimierers zu bewerten und über eine Neuausschreibung oder Nachverhandlung zu entscheiden.",
    "hub.trust.l2":
      "<span class=\"accent\">Investoren und Kreditgeber</span> nutzen es in der Due Diligence, um Businesspläne gegenzuprüfen und zu verstehen, ob vergangene Erlösverläufe vom Betreiber oder vom Markt getrieben waren.",
    "hub.trust.l3":
      "<span class=\"accent\">Optimierer</span> nutzen es, um ihren Mehrwert zu belegen – indem sie zeigen, wie ihre Entscheidungen einem vorsichtigen, physikalisch fundierten Benchmark folgen oder ihn übertreffen.",
    "hub.markets.eyebrow": "ABGEDECKTE MÄRKTE",
    "hub.markets.sub":
      "Der Fokus liegt auf Batteriespeichern im Utility-Maßstab in liberalisierten europäischen Strommärkten.",
    "hub.markets.th_region": "Region",
    "hub.markets.th_energy": "Energieprodukte",
    "hub.markets.th_capacity": "Leistungsprodukte",
    "hub.markets.r1_region": "Frankreich, Deutschland, Österreich",
    "hub.markets.r1_energy":
      "Day-Ahead, Intraday, aFRR-Arbeit, Ausgleichsenergie (Pönalen)",
    "hub.markets.cap_fcr_afrr": "FCR, aFRR-Leistung",
    "hub.markets.r2_region": "Niederlande, Belgien",
    "hub.markets.r2_energy":
      "Day-Ahead, Intraday, Ausgleichsenergie (proaktives Trading)",
    "hub.markets.r3_region":
      "Nordische Länder (Dänemark, Finnland, Norwegen, Schweden)",
    "hub.markets.r3_energy":
      "Day-Ahead, Intraday, aFRR-/mFRR-Arbeit, Ausgleichsenergie (Pönalen)",
    "hub.markets.r3_capacity":
      "FCR-N, FCR-D, FFR, aFRR-Leistung, mFRR-Leistung",
    "hub.markets.r4_region": "Großbritannien",
    "hub.markets.r4_energy":
      "Day-Ahead, Intraday, Balancing Mechanism, Ausgleichsenergie (Pönalen)",
    "hub.markets.r5_region": "Italien",
    "hub.markets.r5_energy":
      "Day-Ahead, Intraday, MSD, Balancing Mechanism, Ausgleichsenergie (Pönalen)",
    "hub.archive_link": "Alle Insights ansehen",
    "hub.cta.eyebrow": "IN KONTAKT BLEIBEN",
    "hub.cta.text":
      "Sagen Sie uns, welche Analysen Sie brauchen oder was Sie in unseren Benchmarks sehen möchten.",
    "hub.cta.btn": "Anruf buchen",
    "hub.cta.note":
      "Oder schreiben Sie an <a href=\"mailto:contact@forsytenergy.com\">contact@forsytenergy.com</a> – wir melden uns bei Ihnen.",
    "hub.modal.eyebrow": "FALLSTUDIE HERUNTERLADEN",
    "hub.modal.title": "Die vollständige Analyse erhalten",
    "hub.modal.text":
      "Geben Sie Ihre geschäftliche E-Mail-Adresse ein, um die Fallstudie BESS Dispatch France zu erhalten.",
    "hub.modal.newsletter":
      "Ausgewählte Analysen, Updates und Mitteilungen von Forsyt erhalten.",
    "hub.modal.consent":
      "Ich stimme den Bedingungen und der <a href=\"privacy.html\" target=\"_blank\" style=\"color: var(--brand); text-decoration: none\">Datenschutzerklärung</a> zu.",
    "hub.modal.submit": "PDF herunterladen",
  },
};
